import { useLocation, useNavigate } from 'react-router-dom'
import { VALID_COUNTRY_CODES } from '@models/ValidCountryCodes'
import { useState } from 'react'
import { UserServices } from '@services/UserServices';
import { Application } from '@core/Application';
import Utils from '@utils/Utils';
import { Logger } from '@utils/Logger';
import { Analytics } from '@core/Analytics/Analytics';

export const useValidateNumberViewModel = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const { name, phone, company } = location.state || {};

    const [loading, setLoading] = useState<boolean>(false);

    const [code, setCode] = useState<string | undefined>(undefined)
    const [codeError, setCodeError] = useState<string | undefined>(undefined)
    const [serviceError, setServiceError] = useState<string | undefined>(undefined)

    const analytics = new AnalyticsHelper()

    const viewDidAppear = () => {
        analytics.trackScreenShown()
    }

    const validateCode = () => {
        if (!code?.trim()) {
            setCodeError("Debes enviar el código que recibiste por WhatsApp".localized());
            return false;
        }
        
        // Check if it contains only numbers and hyphens
        if (!/^[\d\-]+$/.test(code.trim())) {
            setCodeError("El código solo puede contener números y guiones".localized());
            return false;
        }
        
        const codeDigits = code.replace(/\-/g, '');
        if (codeDigits.length < 6) {
            setCodeError("El código es demasiado corto".localized());
            return false;
        }
        
        setCodeError(null);
        return true;
    };

    const handleSubmit = async () => {
        if (!validateCode()) {
            return false
        } 
        setCodeError(undefined)
        setServiceError(undefined)
        setLoading(true)
        let service = new UserServices()

        try {
            let token = await service.getToken(
                phone,
                code
            )
    
            if (token == "") {
                setCodeError("El código que enviaste es incorrecto".localized())
                setLoading(false)
                return false
            }
            Application.shared().setToken(token)
            analytics.trackFormCompleted()
        } catch (error) {
            setServiceError("Hubo un error al intentar validar tu codigo".localized())
            setLoading(false)
            return false
        }

        navigate('/location', { 
            state: { 
                name, 
                phone, 
                company,
            } 
        });

        setLoading(false)

        return true;
    };
    return {
        // state values
        loading,
        name,
        phone,
        company,
        code,
        codeError,
        serviceError,

        // setters
        setLoading,
        setCode,

        // methods,
        handleSubmit,
        viewDidAppear,
    }
}

class AnalyticsHelper {
    private analytics: Analytics
    constructor(analytics: Analytics = Application.shared().coreDependencies.analytics) {
        this.analytics = analytics
    }

    async trackScreenShown() {
        this.analytics.track({
            eventType: 'AutoDemo.PhoneValidationScreen.Shown',
        })
    }

    async trackFormCompleted() {
        this.analytics.track({
            eventType: 'AutoDemo.PhoneValidationScreen.formCompleted',
        })
    }
}